var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _g3, _path17, _g4, _path18, _path19, _path20, _path21, _path22, _g5, _polygon, _polygon2, _path23, _g6, _path24, _rect, _g7, _polygon3, _polygon4, _path25, _g8, _path26, _g9, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodHabit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ed7765;\n      }\n\n      .cls-2 {\n        fill: #e6553f;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #ffeea8;\n      }\n\n      .cls-5 {\n        fill: #ffe65a;\n      }\n\n      .cls-6 {\n        fill: #ffd046;\n      }\n\n      .cls-7 {\n        fill: #fbdd75;\n      }\n\n      .cls-8 {\n        fill: #809127;\n      }\n\n      .cls-9 {\n        fill: #80388b;\n      }\n\n      .cls-10 {\n        fill: #64832c;\n      }\n\n      .cls-11 {\n        fill: #b9ba28;\n      }\n\n      .cls-12 {\n        fill: #e33722;\n      }\n\n      .cls-13 {\n        fill: #24182f;\n      }\n\n      .cls-14 {\n        fill: #9ba72b;\n      }\n\n      .cls-15 {\n        fill: #643589;\n      }\n\n      .cls-16 {\n        fill: #48712f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M214.79,104.11c-10.47-38.11-45.35-66.11-86.79-66.11-49.71,0-90,40.29-90,90,0,41.43,28,76.32,66.11,86.79l110.68-110.68Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M218,128c0-8.27-1.12-16.28-3.21-23.89l-31.45-31.45-110.68,110.68,31.45,31.45c7.61,2.09,15.62,3.21,23.89,3.21,49.71,0,90-40.3,90-90Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128,49.74l-39.13,78.26,39.13,78.26c43.22,0,78.26-35.04,78.26-78.26S171.22,49.74,128,49.74Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.74,128c0,43.22,35.04,78.26,78.26,78.26V49.74c-43.22,0-78.26,35.04-78.26,78.26Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M128,61.48l-33.26,66.52,33.26,66.52c36.74,0,66.52-29.78,66.52-66.52s-29.78-66.52-66.52-66.52Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.48,128c0,36.74,29.78,66.52,66.52,66.52V61.48c-36.74,0-66.52,29.78-66.52,66.52Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M147.57,65.74l-9.78,19.57,9.78,19.57c10.81,0,19.57-8.76,19.57-19.57s-8.76-19.57-19.57-19.57Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128,85.31c0,10.81,8.76,19.57,19.57,19.57v-39.13c-10.81,0-19.57,8.76-19.57,19.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.57,73.57l-5.87,11.74,5.87,11.74c6.48,0,11.74-5.26,11.74-11.74s-5.26-11.74-11.74-11.74Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.83,85.31c0,6.48,5.26,11.74,11.74,11.74v-23.48c-6.48,0-11.74,5.26-11.74,11.74Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M128,69.3l-11.74,39.13,11.74,39.13c21.61,0,39.13-17.52,39.13-39.13s-17.52-39.13-39.13-39.13Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M88.87,108.43c0,21.61,17.52,39.13,39.13,39.13V69.3c-21.61,0-39.13,17.52-39.13,39.13Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M128,77.13l-11.74,31.3,11.74,31.3c17.29,0,31.3-14.02,31.3-31.3s-14.02-31.3-31.3-31.3Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.7,108.43c0,17.29,14.02,31.3,31.3,31.3v-62.61c-17.29,0-31.3,14.02-31.3,31.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128,84.96l-8.8,23.48,8.8,23.48c12.97,0,23.48-10.51,23.48-23.48s-10.51-23.48-23.48-23.48Z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M104.52,108.43c0,12.97,10.51,23.48,23.48,23.48v-46.96c-12.97,0-23.48,10.51-23.48,23.48Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M128,116.26l-10.57,35.22,10.57,35.22c19.45,0,35.22-15.77,35.22-35.22s-15.77-35.22-35.22-35.22Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M92.78,151.48c0,19.45,15.77,35.22,35.22,35.22V116.26c-19.45,0-35.22,15.77-35.22,35.22Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128,124.09l-8.22,27.39,8.22,27.39c15.13,0,27.39-12.26,27.39-27.39s-12.26-27.39-27.39-27.39Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M100.61,151.48c0,15.13,12.26,27.39,27.39,27.39v-54.78c-15.13,0-27.39,12.26-27.39,27.39Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 111.02,
    y: 143.28,
    width: 7.83,
    height: 7.83,
    transform: "translate(-60.57 211.02) rotate(-72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 115.95,
    y: 158.61,
    width: 7.83,
    height: 7.83,
    transform: "translate(-82.08 163.96) rotate(-54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 132.04,
    y: 158.68,
    width: 7.83,
    height: 7.83,
    transform: "translate(-69.61 110.97) rotate(-36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 137.07,
    y: 143.38,
    width: 7.83,
    height: 7.83,
    transform: "translate(-38.61 50.77) rotate(-18)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M147.57,190.26l-9.78-19.57,9.78-19.57c10.81,0,19.57,8.76,19.57,19.57s-8.76,19.57-19.57,19.57Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128,170.69c0-10.81,8.76-19.57,19.57-19.57v39.13c-10.81,0-19.57-8.76-19.57-19.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.57,182.43l-5.87-11.74,5.87-11.74c6.48,0,11.74,5.26,11.74,11.74s-5.26,11.74-11.74,11.74Z"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.83,170.69c0-6.48,5.26-11.74,11.74-11.74v23.48c-6.48,0-11.74-5.26-11.74-11.74Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M159.3,92.78l-10.57,35.22,10.57,35.22c19.45,0,35.22-15.77,35.22-35.22s-15.77-35.22-35.22-35.22Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M124.09,128c0,19.45,15.77,35.22,35.22,35.22V92.78c-19.45,0-35.22,15.77-35.22,35.22Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.3,100.61l-8.22,27.39,8.22,27.39c15.13,0,27.39-12.26,27.39-27.39s-12.26-27.39-27.39-27.39Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.91,128c0,15.13,12.26,27.39,27.39,27.39v-54.78c-15.13,0-27.39,12.26-27.39,27.39Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 155.39,
    y: 110.39,
    width: 7.83,
    height: 7.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 142.33,
    y: 119.8,
    width: 7.83,
    height: 7.83,
    transform: "translate(-16.61 224.58) rotate(-72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 147.25,
    y: 135.13,
    width: 7.83,
    height: 7.83,
    transform: "translate(-50.18 179.61) rotate(-54)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 163.34,
    y: 135.2,
    width: 7.83,
    height: 7.83,
    transform: "translate(-49.83 124.88) rotate(-36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 168.38,
    y: 119.9,
    width: 7.83,
    height: 7.83,
    transform: "translate(-29.83 59.29) rotate(-18)"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "73.22 166.63 81.04 85.06 88.87 85.06 88.87 99.18 84.96 103.09 88.87 107 88.87 130.48 84.96 134.39 88.87 138.31 88.87 166.63 73.22 166.63"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "73.22 107.15 77.13 111.07 73.22 114.98 73.22 166.63 81.04 166.63 81.04 85.06 73.22 85.06 73.22 107.15"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M81.04,177.59l-4.18-24.46,15.92,3.91c0,8.29-5.36,17.43-11.74,20.54Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M76.87,157.04l4.18-20.54c6.38,3.12,11.74,12.26,11.74,20.54h-15.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M69.3,157.04l11.74-3.91v24.46c-6.38-3.12-11.74-12.26-11.74-20.54Z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M69.3,157.04c0-8.29,5.36-17.43,11.74-20.54v20.54h-11.74Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 73.22,
    y: 107.15,
    width: 7.83,
    height: 7.83
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 81.04,
    y: 130.48,
    width: 7.83,
    height: 7.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 81.04,
    y: 99.18,
    width: 7.83,
    height: 7.83
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "88.87 79.62 96.7 190.26 104.52 190.26 104.52 115.91 100.61 112 104.52 108.09 104.52 79.62 88.87 79.62"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "88.87 79.62 88.87 123.74 92.78 127.65 88.87 131.56 88.87 139.39 92.78 143.3 88.87 147.22 88.87 166.78 92.78 170.69 88.87 174.61 88.87 190.26 96.7 190.26 96.7 79.62 88.87 79.62"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M96.7,64.56l-4.18,24.46,15.92-3.91c0-8.29-5.36-17.43-11.74-20.54Z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M92.52,85.11l4.18,20.54c6.38-3.12,11.74-12.26,11.74-20.54h-15.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M84.96,85.11l11.74,3.91v-24.46c-6.38,3.12-11.74,12.26-11.74,20.54Z"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M84.96,85.11c0,8.29,5.36,17.43,11.74,20.54v-20.54s-11.74,0-11.74,0Z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 88.87,
    y: 166.78,
    width: 7.83,
    height: 7.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 88.87,
    y: 139.39,
    width: 7.83,
    height: 7.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 88.87,
    y: 123.74,
    width: 7.83,
    height: 7.83
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 96.7,
    y: 108.09,
    width: 7.83,
    height: 7.83
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodHabit);
export default __webpack_public_path__ + "static/media/food-habit.65f4c94ef9277399f154257d6dabaa83.svg";
export { ForwardRef as ReactComponent };